export enum RappiTravelModules {
  flighs = 'flighs',
  hotels = 'hotels',
  buses = 'buses',
  autos = 'autos'
}
